import React, { useState, useEffect } from 'react';
import Campaigns from './Campaigns';
import * as Util from './../data/General';
import CreateFlow from './CreateFlow';
import UpdatePlan from '../components/html/UpdatePlan';
import AICampaigns from './AICampaigns';


function Flow(props) {

    const [flow, setFlow] = useState(null);
    const [type, setType] = useState("AUTOMATIC");
    const [show, setShow] = useState(true);
    const [newSegment, setNewSegment] = useState(null);
    const [step, setStep] = useState(1);
    const [data, setData] = useState(null);
    const [list, setList] = useState(Util.FLOW_CAMPAIGNS);

    const plan = Util.getAdminShop().plan.planType;
    
  
    const newSegmentCreate = (seg, data=null) => {
        setData(data);
        setNewSegment(seg);
        setFlow(null);
        setShow(false);
        setStep(2);
        
    }

    useEffect(() => {
        let shopJson = Util.getAdminShop();
        if((Util.isTiendaNube(shopJson) || Util.isJumpseller(shopJson) || Util.isVtex(shopJson))){
            setList(Util.FLOW_CAMPAIGNS_TN_NEW);
        }else if(Util.isTiendaNube(Util.getAdminShop())){
            setList(Util.FLOW_CAMPAIGNS_TN);
        }
    },[]);

    const createFlowOnclick = (flow) => {
        if(Util.enabledCampaigns(true)){ 
            setFlow(JSON.parse(JSON.stringify(list[flow])));
            setType(list[flow].type);
        }
    }

    const reloadPage = () => {
        //setStep(0);
        setShow(!show); 
        //setTimeout(() => setStep(step === 1 ? 2 : 1), 1200);
    }
    
    return (
        <div className=''>
            {plan !== "PLUS" ? (
                <AICampaigns type="FLOW" />
            ) : (
                <>
            
                    {flow ? (
                        <CreateFlow configFlow={flow} cancel={() => setFlow(null)} setNewSegment={newSegmentCreate}/>
                    ) : (
                        <>
                            {show ? (<div className='content-flow content-reviews'>
                                <div className='title content-flex space-between space-top'>
                                    {Util.getMessage("flow_title")} 
                                </div>
                                <label>{Util.getMessage("flow_text")}</label>
                                <div className='select-flow'>
                                {list && Object.keys(list).map((key, index) =>
                                    <article key={index} onClick={() => createFlowOnclick(key)}>
                                        <h2>{Util.getMessage(list[key].title)}</h2>
                                        <p>{Util.getMessage(list[key].description)}</p>
                                        <div className='content-flex space-between'>
                                            <img src='/img/ls.png' alt="Shopify" />
                                            <img src='/img/lw.png' alt="WhatsApp" />
                                        </div>
                                    </article>
                                )}
                                </div>
                            </div> ) : null }
                            {step === 0 ? null : step === 1 ? (
                                <Campaigns type={type} editType={setType} show={setShow} setOpenNew={() => reloadPage()} dataExtra = {data} segment={newSegment}/>
                            ) : (
                                <Campaigns type={type} editType={setType} show={setShow} setOpenNew={() => reloadPage()} dataExtra = {data} segment={newSegment}/>
                            )}
                        </>
                    )}
                </>
            )}
        </div>
    );
}

export default Flow;
